module.exports = __webpack_public_path__ + "static/media/wizualizacja-29.7b193ff5.png";